import { assert } from '@ember/debug';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { or } from 'ember-truth-helpers';

import type { IllustrationName } from '../../types/components/prism/illustration.ts';
import PrismIllustration from './illustration.gts';

interface PrismMessageSignature {
  Args: {
    description?: string;
    illustration?: IllustrationName;
    title?: string;
  };
  Blocks: {
    default: [];
    link: [];
    primaryAction: [];
    secondaryAction: [];
  };
  Element: HTMLElement;
}

export default class PrismMessage extends Component<PrismMessageSignature> {
  constructor(owner: Owner, args: PrismMessageSignature['Args']) {
    super(owner, args);

    assert(
      'Prism::Message requires either @title or @description to be provided.',
      Boolean(args.title) || Boolean(args.description),
    );
  }

  <template>
    <section class="prism-message" ...attributes>
      {{#if @illustration}}
        <PrismIllustration
          @name={{@illustration}}
          @size="unsafe_unconstrained"
        />
      {{/if}}

      {{#if @title}}
        <h3 class="prism-message__title">{{@title}}</h3>
      {{/if}}

      {{#if @description}}
        <p class="prism-message__description paragraph-300--regular">
          {{@description}}
        </p>
      {{/if}}

      {{#if (or (has-block "secondaryAction") (has-block "primaryAction"))}}
        <div class="prism-message__actions">
          {{yield to="secondaryAction"}}
          {{yield to="primaryAction"}}
        </div>
      {{/if}}

      {{yield to="link"}}
    </section>
  </template>
}
